var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 .667C6.636.667.667 6.636.667 14 .667 19.97 4.59 25.022 10 26.72V16.524A3.673 3.673 0 0 1 7.333 13V7.333a.667.667 0 0 1 1.333 0v4.333c0 .184.15.334.334.334h1c.184 0 .333-.15.333-.334V7.333a.667.667 0 0 1 1.333 0v4.333c0 .184.15.334.334.334h1c.184 0 .333-.15.333-.334V7.333a.667.667 0 0 1 1.333 0V13A3.673 3.673 0 0 1 12 16.524v10.643c.654.099 1.319.166 2 .166s1.346-.067 2-.166V7.333a.666.666 0 0 1 1.083-.52c.119.095 2.917 2.41 2.917 9.053v.626c0 .462-.18.898-.508 1.225L18 19.21v7.512c5.41-1.7 9.333-6.751 9.333-12.721C27.333 6.636 21.363.667 14 .667Z",
    fill: "#323232"
  })));
};

export default SvgMenu;